import React from 'react';
import { Link } from 'react-router-dom';

const RoleDashboardTemplate = ({ title, subtitle, modules = [], emptyTitle = 'No modules currently allowed', emptyMessage = 'Your Organization Head or Organization Admin has not enabled any workspace modules yet.' }) => {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="rounded-3xl border bg-white p-5 shadow-sm" style={{ borderColor: '#f2d8e0' }}>
        <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
        <p className="text-sm text-slate-500 mt-1">{subtitle}</p>
      </div>

      {modules.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 mt-5">
          {modules.map((module) => (
            <div key={module.title} className="rounded-2xl border bg-white p-4 shadow-sm" style={{ borderColor: '#f4d9e1' }}>
              <h2 className="text-base font-bold text-slate-800">{module.title}</h2>
              <p className="text-sm text-slate-500 mt-1">{module.description}</p>
              {module.link ? (
                <Link
                  to={module.link}
                  className="inline-flex mt-3 px-3 py-2 rounded-xl text-xs font-semibold text-white"
                  style={{ background: '#c44569' }}
                >
                  Open Module
                </Link>
              ) : null}
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-5 rounded-3xl border bg-white p-6 text-center shadow-sm" style={{ borderColor: '#f4d9e1' }}>
          <h2 className="text-lg font-bold text-slate-900">{emptyTitle}</h2>
          <p className="mt-2 text-sm text-slate-500">{emptyMessage}</p>
        </div>
      )}
    </div>
  );
};

export default RoleDashboardTemplate;
